import { render } from "./DraftProfilePopup.vue?vue&type=template&id=070c76b8&scoped=true"
import script from "./DraftProfilePopup.js?vue&type=script&lang=js&external"
export * from "./DraftProfilePopup.js?vue&type=script&lang=js&external"

import "./DraftProfilePopup.css?vue&type=style&index=0&id=070c76b8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070c76b8"]])

export default __exports__